/**
 * Страница отображения уведомления
 *
 * Особенности в работе:
 *  на данный момент уведомление по Турниру приходит в виде верстки,
 *  и на макете может быть реклама событий с возможностью подписки,
 *  специфика при поиске кнопки подписи, необходимо чтобы она содержала
 *  класс subscribe-button
 **/

import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Notification } from '@app/definitions/interfaces';

@Component({
    selector: 'app-profile-notification',
    templateUrl: './profile-notification.component.html',
    styleUrls: ['./profile-notification.component.scss']
})
export class NotificationComponent implements OnInit {
    notification: Notification;
    appEvent: any;
    subscribed = false;

    constructor(
        private handlerService: HandlerService,
        private notificationsService: NotificationsService,
        private activatedRoute: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        const notificationId = this.activatedRoute.snapshot.params['notification_id'];
        this.getNotification(notificationId);
    }

    private transDataWithHtml(htmlTextWithStyle) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
    }

    private checkSubscribeAppEvent(): void {
        const adId = this.notification.ad_template;
        if (adId) {
            this.notificationsService.checkSubscribeAppEvent(adId).subscribe(resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.error) {
                    this.subscribed = resp.subscribe;
                }
            });
        }
    }

    private checkUrlForSubscribe() {
        const urlParams = new URLSearchParams(document.location.search);
        if (urlParams.get('subscribe')) {
            this.subscribed = !!urlParams.get('subscribe');
            this.subscribeAppEvent();
        }
    }

    private changeButton(el) {
        el.innerText = this.subscribed ? 'Отписаться' : 'Записаться';
        el.style.backgroundColor = this.subscribed ? 'grey' : '#f2005d';
    }

    private connectOnclickForSubscribe(el) {
        el.onclick = () => {
            this.subscribed = !this.subscribed;
            this.changeButton(el);
            this.subscribeAppEvent();
            return false;
        };
    }

    private checkSubscribeButton() {
        setTimeout(() => {
            if (document.querySelectorAll('.subscribe-button').length) {
                const el: any = document.querySelectorAll('.subscribe-button')[0];
                this.changeButton(el);
                this.connectOnclickForSubscribe(el);
            }
        }, 1000);
    }

    private checkSubscribe() {
        this.checkUrlForSubscribe();
        this.checkSubscribeAppEvent();
        this.checkSubscribeButton();
    }

    private getNotification(id): void {
        this.notificationsService.getNotification(id).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.notification = resp.data;
                this.notification.description = this.transDataWithHtml(this.notification.description);
                this.checkSubscribe();
            }
        });
    }

    private subscribeAppEvent(): void {
        const adId = this.notification.ad_template;
        if (adId) {
            this.notificationsService.subscribeAppEvent(adId, +this.subscribed).subscribe(resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.error && resp.data.success_msg) {
                    this.handlerService.successMsg(resp.data.success_msg);
                    this.subscribed = resp.data.subscribe;
                }
            });
        }
    }
}
